import * as dayjs from 'dayjs';
import { z } from 'zod';

/**
 * Custom zod schema for dayjs dates
 */
export const zDayJs = z.custom<dayjs.Dayjs>(
  value => {
    // Check if value is a dayjs instance
    return dayjs.isDayjs(value);
  },
  {
    message: 'Invalid date: must be a dayjs instance',
  },
);

/**
 * Shared helper to extend common date range schema
 */
export const withDateRangeSchema = (opts?: { startDate?: dayjs.Dayjs; endDate?: dayjs.Dayjs }) => {
  const start = opts?.startDate || dayjs().subtract(7, 'd').startOf('day');
  const end = opts?.endDate || dayjs().endOf('day');

  return z.object({
    start_date: zDayJs.catch(start),
    end_date: zDayJs.catch(end),
  });
};

/**
 * Shared helper to extend common date schema
 */
export const withDateSchema = (opts?: { date?: dayjs.Dayjs }) => {
  const date = opts?.date || dayjs().startOf('day');

  return z.object({
    date: zDayJs.catch(date),
  });
};
